const ShouldAutoFocus = (refElement) => {
    if (!refElement)
        return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll('*[data-autofocus],*[autofocus]').length);
    return !autoFocusSet;
};
export default ShouldAutoFocus;
